import { SearchFilter, SearchFilterFilterTypeEnum } from 'typescript-fetch-api'

export type HnzProductsNavigationParams = {
	id?: string
	name?: string
}

export const HnzSearchFilter: SearchFilter = { filterType: SearchFilterFilterTypeEnum.HNZ, name: 'Kāinga ora' }
